import type { SharedFolderSummary } from '../api/client';

let cachedFolders: SharedFolderSummary[] | null = null;
const cachedLabels = new Map<string, string>();

export function cacheSharedFolders(folders: SharedFolderSummary[]): void {
  cachedFolders = folders;
}

export function cacheSharedFolderLabel(folderId: string, label: string): void {
  cachedLabels.set(folderId, label);
}

export function getCachedSharedFolders(): SharedFolderSummary[] | null {
  return cachedFolders;
}

export function getCachedSharedFolderLabel(folderId: string): string | undefined {
  return cachedLabels.get(folderId);
}
